const BANNEDWORDS = ['anal','anus','arse','ass','ballsack','balls','bastard','bitch','biatch','bloody','blowjob','blow job','bollock','bollok','boner','boob','bugger','bum','butt','buttplug','clitoris','cock','coon','crap','cunt','damn','dick','dildo','dyke','fag','feck','fellate','fellatio','felching','fuck','f u c k','fudgepacker','fudge packer','flange','Goddamn','God damn','hell','homo','jerk','jizz','knobend','knob end','labia','lmao','lmfao','muff','nigger','nigga','omg','penis','piss','poop','prick','pube','pussy','queer','scrotum','sex','shit','s hit','sh1t','slut','smegma','spunk','tit','tosser','turd','twat','vagina','wank','whore','wtf'];

Vue.component('battleHelper', {
  template: templates.battleHelper,
  data() {
    return {
      model: {
        open: false,
        counts: {
          min: 4,
          max: 4
        },
        battle: {
          action: '',
          displayName: '',
          command: '',
          cards: [],
          count: 0,
          enabled: false,
          teamName: '',
          teams: [],
          team: '',
          validName: false
        },
        selected: null,
        pressTimer: 0
      }
    }
  },
  mounted() {
    const c = this;

    c.getTeams();

    $('[data-view="viewer-dashboard"]').on('click', '[data-number]', function(e) {
      if (e.ctrlKey) {
        c.model.selected = $(this);
        console.log($(this))
        console.log(c.model)
        c.selectCard();
      }
    }).on('mousedown pointerdown', '[data-number]', function() {
      c.model.selected = $(this);
      c.model.pressTimer = setTimeout(function() { 
        c.selectCard($(this));
        utils.onHold = true;
      }, 1000);
      return false; 
    }).on('mouseup pointerup', '[data-number]', function(e) {
      //e.stopPropagation();
      clearTimeout(c.model.pressTimer);
      c.model.pressTimer = null;
      setTimeout(function() { 
        utils.onHold = false;
      }, 1000);
      return false;
    });
  },
  methods: {
    open() {
      this.model.open = !this.model.open;
    },
    getTeams() {
      const c = this;
      userService.getTeams()
      .then(function (response) {
        for (let data of response.data) {
          data.cards = data.cards.split(',');
          c.model.battle.teams.push(data);
        }

      });
    },
    selectCard() {
      const c = this;
      c.addCard(c.model.selected);
      c.generateCommand();
    },
    addCard($card) {
      const c = this;
      const number = $card.attr('data-number');
      const cooldown = $card.attr('data-cooldown');

      if (cooldown) {
        return;
      }

      if (c.model.battle.cards.includes(`#${number}`)) {
        c.$root.$emit('selectCard', {number: number, toggle: false});
        $card.removeClass('selected');
        c.model.battle.cards.splice(c.model.battle.cards.indexOf(`#${number}`), 1);
      } else if (c.model.battle.count < c.model.counts.max) {
        c.$root.$emit('selectCard', {number: number, toggle: true});
        $card.addClass('selected');
        c.model.battle.cards.push(`#${number}`);
      }

      c.model.battle.count = c.model.battle.cards.length;
    },
    selectTeam() {
      const c = this;

      $('[data-component="playing-card"].selected').each(function() {
        c.addCard($(this));
      });

      c.model.battle.cards = [];

      if (c.model.battle.team) {
        c.model.battle.teamName = c.model.battle.team.name;
        for (let card of c.model.battle.team.cards) {
          c.addCard($(`[data-number=${card.replace('#', '')}]`));
        }
      } else {
        c.model.battle.teamName = '';
      }

      c.cleanName();
      c.generateCommand();
    },
    generateCommand() {
      const c = this;

      $('[data-component="navigation"] li:first-of-type button').trigger('click');

      if (c.model.battle.team) {
        for (let card of c.model.battle.team.cards) {
          $(`[data-number="${card}"]`).addClass('selected');
        }
      }

      c.model.battle.enabled = false;
      if ((c.model.battle.action && c.model.battle.displayName) && (c.model.battle.cards.length || c.model.battle.team)) {
        c.model.battle.enabled = true;
      }

      let command = `!${c.model.battle.action.toLocaleLowerCase()} @${c.model.battle.displayName}`;

      if (c.model.battle.team) {
        command = `${command} #${c.model.battle.team.name}`;
      } else {
        command = `${command} ${c.model.battle.cards.join(', ')}`;
      }

      c.model.battle.command = command;

      setTimeout(function() {
        let element = document.getElementById('command');
        element.style.height = '1px';
        element.style.height = (2 + element.scrollHeight) + 'px';  
      }, 50);
    },
    copyCommand() {
      const c = this;

      let copyText = document.getElementById('command');
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      document.execCommand('copy');
    },
    cleanName() {
      const c = this;

      c.model.battle.teamName = c.model.battle.teamName.replace(/[\W_]+/g, '').trim();

      if (BANNEDWORDS.some(function(v) { return c.model.battle.teamName.toLocaleLowerCase().indexOf(v) >= 0; })) {
        utils.alert.error("Let's keep it a bit clean.");
        c.model.battle.validName = false;
      } else {
        c.model.battle.validName = true;
      }
      
    },
    saveTeam() {
      const c = this;
      console.log(c.model)
      let cards = JSON.parse(JSON.stringify(c.model.battle.cards));

    

      let data = {
        name: c.model.battle.teamName,
        cards: cards.join(',')
      }
      console.log(data)

      for (let team of c.model.battle.teams) {
        if (team.name == c.model.battle.teamName || team.name == c.model.battle.team.name) {
          c.model.battle.team.name = c.model.battle.teamName;
          data.id = team.id;
          break;
        }
      }

      userService.saveTeam(data)
        .then(function (response) {

          if (!data.id) {
            c.model.battle.teamName = '';
          }

          data.id = response.data.id;
          data.cards = cards;

          c.model.battle.teams.push(data);

          utils.alert.success('Team saved!');

        })
        .catch(function (error) {
          utils.alert.error('Failed to save team!');
        });

    },
    deleteTeam() {
      const c = this;

      var result = confirm("Are you sure you want to delete this team?");
      if (result == true) {

        let id = null;
  
        for (let team of c.model.battle.teams) {
          if (team.name == c.model.battle.teamName) {
            id = team.id;
            break;
          }
        }

        userService.deleteTeam({id: id})
          .then(function (response) {
            console.log(response)
            
            for (let i in c.model.battle.teams) {
              if (id == c.model.battle.teams[i].id) {
                c.model.battle.teams.splice(i, 1);
                break;
              }
            }

            c.model.battle.teamName = '';

            utils.alert.success('Team deleted!', 'success');
          })
          .catch(function (error) {
            utils.alert.error('Failed to delete team!');
          });

      }
    }
  }
});